import { render, staticRenderFns } from "./ActionSuperAdmin.vue?vue&type=template&id=50486343&"
import script from "./ActionSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./ActionSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports